import { Typography } from "@mui/material";
import { QuestionBreakdown } from "../../types/workplaceCulture";
import { Tab } from "../ui/Tabs/Tab";
import "./QuestionBreakdownOverview.scss";

interface QuestionBreakdownTabProps {
  isFirstInGroup: boolean;
  groupKey?: string;
  tabClasses: string;
  questionResponse: QuestionBreakdown;
  selected: boolean;
  tabIndex: number;
  handleTabChange: (index: number) => void;
}

export const QuestionBreakdownTab = ({
  isFirstInGroup,
  groupKey,
  tabClasses,
  questionResponse,
  selected,
  tabIndex,
  handleTabChange,
}: QuestionBreakdownTabProps) => {
  return (
    <div className="QuestionBreakdownOverview__content__questions__tab">
      {isFirstInGroup && groupKey && (
        <Typography
          className="QuestionBreakdownOverview__content__questions__tab__groupTitle"
          color="secondary"
          variant="h6"
        >
          {groupKey}
        </Typography>
      )}
      <div className={tabClasses}>
        <Tab
          key={questionResponse.reference_id}
          selected={selected}
          label={questionResponse.text}
          index={tabIndex}
          onClick={() => handleTabChange(tabIndex)}
        />
      </div>
    </div>
  );
};
